// extracted by mini-css-extract-plugin
export default {"form-container":"InputTemplateForm_form-container__MJo-Q","formContainer":"InputTemplateForm_form-container__MJo-Q","field":"InputTemplateForm_field__9L48O"};